// extracted by mini-css-extract-plugin
module.exports = {"applyMargin":"CriteriaFilter_applyMargin_1cW44","dropdownItem":"CriteriaFilter_dropdownItem_3d6kt","spinAround":"CriteriaFilter_spinAround_pXVm1"};